import React from 'react'
import { translate } from 'react-i18next'
import { Col, Row } from 'antd';
// import { isMobile } from 'react-device-detect'

const SupportHeader = ({ t }) => {
    return (
        <>
            <Row>
                <Col span={24}>
                    {/* { !isMobile ?  */}
                    <section className="support-headers">
                        <p className="support-text-header">
                            {t("menu_support")}
                        </p>
                    </section>
                    {/* :
                    null
                    } */}
                </Col>
            </Row>
        </>
    )
}

export default translate()(SupportHeader)
